<div class="simple-back">
  <div class="fwc-container no-head-padding btm-pad-lg">
    <div class="fwc-row">
      <div class="fwc-col-12">
        <div class="pnf-container">
          <img class="pnf-image" src="./assets/images/404.png">
          <h3 class="top-sm">The page you are trying to visit does not exist.</h3>
          <h4 class="top-xs">It’s possible that the web address is out of date or was typed incorrectly.</h4>
        </div>
      </div>
    </div>
  </div>
</div>
